export default __webpack_public_path__ + "static/media/Review 1.6016dcd9.png";